import { AttendeeConnectionControlService } from './attendee-connection-control-service';

let activityAttendeeCountService: null | AttendeeConnectionControlService = null;

const getAttendeeConnectionControlService = (): AttendeeConnectionControlService => {
  if(activityAttendeeCountService === null) {
    activityAttendeeCountService = new AttendeeConnectionControlService();
  }

  return activityAttendeeCountService;
};

export { getAttendeeConnectionControlService };